import React, { useEffect, useMemo, useState } from 'react';
import { Button, SplitButton, SplitButtonItemClickEvent } from '@progress/kendo-react-buttons';
import { Window, WindowActionsBar, WindowActionsEvent } from '@progress/kendo-react-dialogs';
import { ComboBox, DropDownList, MultiSelect } from '@progress/kendo-react-dropdowns';
import { DateRangePicker, SelectionRange } from '@progress/kendo-react-dateinputs';
import { Checkbox, } from '@progress/kendo-react-inputs';
import { SvgIcon } from '@progress/kendo-react-common';
import { PartialSpinny } from '../../../../../Nav/Spinny';
import * as svg from '@progress/kendo-svg-icons';
import { isMobile } from 'react-device-detect';
import { UserApi } from '../../../../../../redux/api/UserApi';
import { useNavigate, useParams } from 'react-router-dom';
import { useReduxDispatch, useReduxSelector } from '../../../../../../redux/hooks';
import * as FilterSlice from '../../../../../../slices/FilterSlice';
import { TicketApi } from '../../../../../../redux/api/TicketApi';
import { TextBox } from '@progress/kendo-react-inputs';
import { Setting } from '../../../../../../types/Setting/Setting';
import { isDate } from 'lodash';
import { ISetting } from '../../../../../../types/User/ISetting';
import { toast } from 'react-toastify';

const ActionFilter: React.FC = () => {
    const { ticketId } = useParams()
    const navigate = useNavigate();
    const { data: userProfile } = UserApi.useGetUserProfileQuery();
    const [saveSetting, { isLoading: isSaving }] = UserApi.useSaveSettingMutation();
    const [stage, setStage] = useState(isMobile ? 'FULLSCREEN' : 'DEFAULT');
    const sharingTicket = false;
    const [formState, setFormState] = useState(null as FilterState);

    //const [searchTerm, setSearchTerm] = useState('');

    //The filter state is managed by redux
    const filter = useReduxSelector(state => state.filter);
    const updateState = useReduxDispatch();
    const { data: staffList, isLoading: staffLoading } = TicketApi.useGetTicketAuthorsQuery(parseInt(ticketId));
    const { data: actionTypes } = TicketApi.useGetTicketActionTypesQuery(parseInt(ticketId));
    const selectedStaff = staffList?.filter((staff) => formState?.authorIds?.indexOf(staff.ID) > -1);
    const toggleModal = () => {
        navigate(-1);
    };


    //Load the curtrent filter state into the form
    useEffect(() => {
        if (filter)
            setFormState(filter);
    }, [filter]);

    const resetClicked = (e: any) => {

        updateState(FilterSlice.resetFilters());
        //updateState(FilterSlice.setAuthors([value.ID]));
        toggleModal();
    }


    const handleFilter = () => {
        var errors = [] as string[];
        //Val;idate the form
        if (formState?.dateRange === 'Custom' && (!formState?.customStartDate || !formState?.customEndDate)) {
            errors.push('Please select a valid date range.')
        }

        if (errors.length) {
            setFormState(s => { return { ...s, errors: errors } });
            return;
        }

        // Implement filter logic here
        console.log('handleFilter');
        updateState(FilterSlice.setSearchTerm(formState.searchTerm));
        updateState(FilterSlice.setSearchTermOption(formState.searchTermOption));
        updateState(FilterSlice.setAuthors(formState.authorIds));
        updateState(FilterSlice.setAuthorAndOr(formState.authorIds !== FilterSlice.initialState.authorIds ? formState.authorAndOr : FilterSlice.initialState.authorAndOr));
        updateState(FilterSlice.setHasReaction(formState.hasReactions));
        updateState(FilterSlice.setActionTypes(formState.actionTypeIds));
        updateState(FilterSlice.setActionTypeAndOr(formState.actionTypeIds !== FilterSlice.initialState.actionTypeIds ? formState.actionTypeAndOr : FilterSlice.initialState.actionTypeAndOr));
        updateState(FilterSlice.setDateRange(formState.dateRange));
        updateState(FilterSlice.setStartDate(formState.dateRange === 'Custom' ? formState.customStartDate : null));
        updateState(FilterSlice.setEndDate(formState.dateRange === 'Custom' ? formState.customEndDate : null));
        updateState(FilterSlice.setAuthors(formState.authorIds));
        updateState(FilterSlice.setShowSystemActions(formState.showSystemActions));
        toggleModal();
    };

    //navigate back when the winow is closed
    const onStageChange = (e: WindowActionsEvent) => {
        //setVisible(false);
        setStage(e.state)

    }

    const onWindowClose = () => {
        toggleModal();
    }

    //Save as default
    const itemClicked = (e: SplitButtonItemClickEvent) => {
        console.log('itemClicked', e);
        var stringValues = [] as string[];
        //Authors
        stringValues.push(formState.authorIds.join(','));
        //Authors And Or
        stringValues.push(formState.authorAndOr);
        //Action Types
        stringValues.push(formState.actionTypeIds.join(','));
        //Action Types And Or
        stringValues.push(formState.actionTypeAndOr);
        //Include / Exclude search term
        stringValues.push(formState.searchTermOption === 'Include' ? '1' : '0');
        //Search Term
        stringValues.push(formState.searchTerm);
        //System actions
        stringValues.push(formState.showSystemActions.toString());
        //Date range
        stringValues.push(formState.dateRange);
        //From date
        stringValues.push(formState.dateRange !== 'Custom' ? null : (formState.customStartDate && formState.customStartDate.toISOString()));
        //To date
        stringValues.push(formState.dateRange !== 'Custom' ? null : (formState.customEndDate && formState.customEndDate.toISOString()));
        //HAs reactions
        stringValues.push(formState.hasReactions.toString());

        //push settings to the API
        saveSetting({ Setting_Id: Setting.Ticket_Action_Filter, String_Value: stringValues.join(';') } as ISetting).then(() =>
            toast.success('Default Filter settings saved successfully')
        );
    }

    const selectedActionTypes = useMemo(() => actionTypes?.filter((at) => formState?.actionTypeIds?.indexOf(at.ID) > -1), [actionTypes, formState]);

    const buttonStyleCss = `.rev-action-button button,.rev-action-button button:hover {color: #fff; background-color: ${userProfile?.Nav_Hex_Color};}
    .rev-action-button button:hover {opacity: 0.8;}`;

    if (userProfile?.Features.Call_Action_Filter === false) return null;

    return (
        <div>
            <Window modal={true} className='cool-window' minimizeButton={() => null} title={<><SvgIcon size='medium' icon={svg.filterIcon} className='mr-2' ></SvgIcon>Filter</>} onClose={onWindowClose} initialHeight={520} initialWidth={window.innerWidth < 700 ? window.innerWidth : 700} stage={stage} onStageChange={onStageChange} >
                <style>{buttonStyleCss}</style>
                <div className='position-relative'>
                    {sharingTicket && <PartialSpinny />}
                    <form id='action-filter' className='w-100 d-flex flex-column' onSubmit={handleFilter}>
                        {formState?.errors && (
                            <div className="alert alert-danger" role="alert">
                                {formState?.errors.map((e, i) => <div key={i}>{e}</div>)}
                            </div>
                        )}
                        <div className="w-100 mb-3 row">
                            <div className='d-flex flex-column col'>
                                <label className=''>Author</label>
                                <div className='d-flex flex-row'>
                                    <MultiSelect size='large' placeholder='Select one or more...' className='mr-1' loading={staffLoading}
                                        data={staffList}
                                        filterable={false}
                                        allowCustom={false}
                                        dataItemKey='ID'
                                        textField='Full_Name'
                                        value={selectedStaff}
                                        onChange={(e) => setFormState((s) => {
                                            console.log('onChange', e.target.value);
                                            return { ...s, authorIds: e.target.value.map(a => a.ID) }
                                        })}

                                    />
                                    <DropDownList fillMode='solid' value={formState?.authorAndOr} data={['and', 'or']} style={{ width: 100 }}
                                        onChange={(e) => setFormState((s) => {
                                            return { ...s, authorAndOr: e.target.value }
                                        })}
                                    />
                                </div>
                            </div>

                        </div>
                        <div className="col-12 mb-2 row">
                            <label>Action Types</label>
                            <div className='d-flex flex-row'>
                                <MultiSelect size='large'
                                    filterable={false}
                                    allowCustom={false}
                                    value={selectedActionTypes}
                                    placeholder='Select one or more'
                                    textField='Action_Type'
                                    className='w-100'
                                    data={actionTypes?.filter((a) => formState?.showSystemActions === true || a.Is_System == false).sort((a, b) => a.Action_Type < b.Action_Type ? -1 : 1)}
                                    dataItemKey='ID'
                                    onChange={(e) => setFormState((s) => {
                                        console.log('onChange', e.target.value, formState?.actionTypeIds);
                                        return { ...s, actionTypeIds: e.target.value.map(a => a.ID) }
                                    })}
                                />
                                <DropDownList fillMode='solid' value={formState?.actionTypeAndOr} data={['and', 'or']} style={{ width: 100 }}
                                    onChange={(e) => setFormState((s) => { return { ...s, actionTypeAndOr: e.target.value.toString() } })}
                                />
                            </div>
                            {userProfile?.Features.View_System_Actions &&
                                <Checkbox label="Show System Actions" className='m-2' checked={formState?.showSystemActions}
                                    onChange={(e) => setFormState((s) => { return { ...s, showSystemActions: e.target.value === true } })} />}
                        </div>
                        <div className="col-12 row">

                            <div className='w-50 inline-block mt-0'><label>Date Range</label>
                                <ComboBox placeholder='None'
                                    value={formState?.dateRange}
                                    data={['Today', 'Yesterday', 'This Week', 'Last Week', 'This Month', 'Last Month', 'Last 3 Months', 'Custom']}
                                    onChange={(e) => setFormState((s) => { return { ...s, dateRange: e.target.value } })}
                                />

                            </div>
                            {formState?.dateRange === 'Custom' && (
                                <div className="w-50 inline-block ">
                                    <DateRangePicker className='range-picker'
                                        value={{ start: formState?.customStartDate ? new Date(formState?.customStartDate) : null, end: new Date(formState?.customEndDate || '') } as SelectionRange}
                                        onChange={(e) => setFormState((s) => {
                                            console.log('DateRangePicker', JSON.stringify(e.target.value), isDate(e.target.value?.end));
                                            return { ...s, customStartDate: e.target.value?.start, customEndDate: e.target.value?.end && new Date(e.target.value?.end) }
                                        })}
                                    />
                                </div>)}
                        </div>

                        <div className="w-100 mt-3 row">
                            <div className='d-flex flex-column col'>
                                <label>Notes</label>
                                <div className='d-flex flex-row'>
                                    <DropDownList value={formState?.searchTermOption} style={{ width: 200 }}
                                        data={['Include', 'Exclude']}
                                        onChange={(e) => setFormState((s) => { return { ...s, searchTermOption: e.target.value.toString() } })} />
                                    <TextBox className='w-80' placeholder='Word or phrase' size='large'
                                        value={formState?.searchTerm}
                                        onChange={(e) => setFormState((s) => {
                                            return { ...s, searchTerm: e.target.value.toString() }
                                        })}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="col-12 mt-3 row">
                            <Checkbox className='m-2' checked={formState?.hasReactions} label='Has Reaction'
                                onChange={(e) => setFormState((s) => {
                                    return { ...s, hasReactions: e.target.value === true }
                                })} />
                        </div>
                        {/* <JsonTreeViewer title="redux data" data={filter} /> */}
                        {/* <JsonTreeViewer title="form State" data={formState} />
                         */}
                    </form>
                </div>
                <WindowActionsBar>
                    <SplitButton buttonClass='p-2' text=' Apply Filter' svgIcon={svg.filterIcon} items={['Set as default filter']} onItemClick={itemClicked} onButtonClick={handleFilter} className='rev-action-button justify-content-end p-2' style={{ marginTop: '10px' }}>
                    </SplitButton>
                    <Button fillMode='outline' svgIcon={svg.cancelIcon} className='justify-content-end p-2' style={{ marginTop: '10px' }}
                        onClick={resetClicked} >
                        Clear Filter
                    </Button>
                </WindowActionsBar>
            </Window>

        </div >
    );
};

export default ActionFilter;